import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-inventory-manager-ss',
  templateUrl: './inventory-manager-ss.component.html',
  styleUrls: ['./inventory-manager-ss.component.scss']
})
export class InventoryManagerSSComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
